var _slicedToArray = require("@babel/runtime/helpers/slicedToArray");
/* eslint-disable no-underscore-dangle */

const evaluateSource = require(/* webpackIgnore: true */'../lib/evaluateSource');

/**
  * @function evalute - evaluate phasedArrayInspectionBehavior
  */

// This behavior goes and finds reports that are
// in draft or submitted status that contain specific
// flanges in `relatedJobs`

const evaluate = async (source, content, parentContentPath, transientContext, nativeFunctions) => {
  const clientSource = {
    type: 'clientInfoBehavior'
  };
  const _await$evaluateSource = await evaluateSource.evaluateSource(clientSource, content, parentContentPath, transientContext, nativeFunctions),
    clientType = _await$evaluateSource.clientType;
  const getReports = async jobID => {
    // TODO: remove this bifurcation when
    // #177873523 (ipad) and #183560909 (server)
    // are fixed.
    const querySourceServer = {
      type: 'queryReportsBehavior',
      jobID,
      reportTypeIdentifiers: ['phasedArrayInspectionReport'],
      reportStatusIdentifiers: ['draft', 'submitted']
    };
    const querySourceIPad = {
      type: 'queryEntityBehavior',
      entityName: 'Report',
      properties: ['appCreated', 'content', 'job/jobNumber'],
      equals: {
        'reportType/identifier': 'phasedArrayInspectionReport',
        'job/id': jobID
      },
      equalsOneOf: {
        'latestStatusHistory/status/identifier': ['draft', 'submitted']
      },
      orderBy: [{
        property: 'appCreated',
        ascending: true
      }]
    };
    const querySource = {
      ipad: querySourceIPad,
      server: querySourceServer
    }[clientType];
    const reports = await evaluateSource.evaluateSource(querySource, content, parentContentPath, transientContext, nativeFunctions);
    if (reports.length === 0) {
      return undefined;
    }
    const result = {};
    reports.forEach(report => {
      const id = report.id,
        appCreated = report.appCreated,
        reportContent = report.content;
      const _JSON$parse = JSON.parse(reportContent),
        currentState = _JSON$parse.currentState;
      result[id] = {
        appCreated,
        currentState
      };
    });
    return result;
  };
  const relatedJobsSource = {
    type: 'readJobContentBehavior',
    contentPath: 'relatedJobs'
  };
  const relatedJobs = (await evaluateSource.evaluateSource(relatedJobsSource, content, parentContentPath, transientContext, nativeFunctions)) || {};
  const matingFlange = relatedJobs.matingFlange,
    relatedFlanges = relatedJobs.relatedFlanges;
  const result = {};
  if (matingFlange !== undefined) {
    const _Object$keys = Object.keys(matingFlange),
      _Object$keys2 = _slicedToArray(_Object$keys, 1),
      matingID = _Object$keys2[0];
    const matingTitle = matingFlange[matingID].title;
    const matingReport = {};
    matingReport[matingID] = {
      jobNumber: matingTitle,
      _created: matingTitle,
      children: await getReports(matingID)
    };
    result.matingFlange = matingReport;
  }
  if (relatedFlanges !== undefined) {
    const relatedIDs = Object.keys(relatedFlanges);
    const relatedReports = {};
    for (let i = 0; i < relatedIDs.length; i += 1) {
      const relatedID = relatedIDs[i];
      const relatedTitle = relatedFlanges[relatedID].title;
      relatedReports[relatedID] = {
        jobNumber: relatedTitle,
        _created: relatedTitle,
        // eslint-disable-next-line no-await-in-loop
        children: await getReports(relatedID)
      };
    }
    result.relatedFlanges = relatedReports;
  }
  return result;
};
module.exports = {
  evaluate
};